import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"

import { Link } from "gatsby"
import { Container, Row, Col, Image } from "react-bootstrap"
import { Helmet } from "react-helmet"
import SolutionCard from "../../components/SolutionCard"
import TRAVEL_GUIDE from "../../../assets/images/travel-guide.png"
import QualityControlModal from "../../components/QualityControlModal"
import RiskManagementModal from "../../components/RiskManagementModal"
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import NewsCard from "../../components/NewsCard"
import PatentsCard from "../../components/PatentsCard"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"
import { useGlobalState } from "../../global/global"
import { getLanguageFile } from "../../global/langauge.helper"
import { NEWS_ITEMS } from "../../global/newsConfig"
import { getRecentNews } from "../../global/news.helper"
import CUBES from "../../../assets/images/careerDetailCubes.png"

import trademark_adam_staff from "../../../assets/images/trademark_adam_staff.png"
import trademark_arts from "../../../assets/images/trademark_arts.png"
import trademark_batp from "../../../assets/images/trademark_batp.png"
import trademark_hymots from "../../../assets/images/trademark_hymots.png"
import trademark_nginr from "../../../assets/images/trademark_nginr.png"
import trademark_etecube from "../../../assets/images/trademark_etecube.png"
// import trademark_sama_isr from "../../../assets/images/trademark_sama_isr.png"
import SERTIFIKA_KALITE from "../../../assets/images/SERTIFIKA_KALITE_YONETIM_SISTEMI.png"
import SERTIFIKA_AQAP from "../../../assets/images/sertifika_aqap.png"
import BASIN_BULTENI_EFES from "../../../assets/images/BasinBulteni_Efes2026_eng.png"
import BASIN_BULTENI_CATALYST from "../../../assets/images/BasinBulteni_Catalyst_eng.png"
import BASIN_BULTENI_CATALYST_SPRINT3_EN from "../../../assets/images/BasinBulteni_Catalyst_Sprint3_eng.png"
import BASIN_BULTENI_CATALYST_SPRINT3_TR from "../../../assets/images/BasinBulteni_Catalyst_Sprint3_tr.png"
import ETE_PRODUCTS from "../../../assets/images/ETE_PRODUCTS.png"

import "./styles.scss"

const AboutUsPage = () => {
  const [state] = useGlobalState()

  const [showModal, setShowModal] = React.useState(false)
  const [showRiskModal, setShowRiskModal] = React.useState(false)
  const [currentDate, setCurrentDate] = React.useState(null)

  React.useEffect(() => {
    let timeoutId
    const refreshNews = () => {
      const now = new Date()
      setCurrentDate(now)
      const nextDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      )
      timeoutId = window.setTimeout(
        refreshNews,
        nextDay.getTime() - now.getTime()
      )
    }

    refreshNews()
    return () => window.clearTimeout(timeoutId)
  }, [])

  const recentNews = currentDate ? getRecentNews(NEWS_ITEMS, currentDate) : []
  const aboutUsText = getLanguageFile(state.language).AboutUs

  const sliderSettings = {
    dots: recentNews.length > 1,
    infinite: false,
    slidesToShow: Math.min(3, recentNews.length),
    slidesToScroll: 1,
    autoplay: recentNews.length > 1,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: Math.min(2, recentNews.length),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: Math.min(2, recentNews.length),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <Container fluid className="main-container">
      <div className="application">
        <Helmet title={getLanguageFile(state.language).Title.aboutUs}>
          <meta charSet="utf-8" />
        </Helmet>
      </div>
      <Header />
      <Container fluid className="about-us-image-container">
        <Image className={"about-us-image-background"} src={CUBES} />
      </Container>
      <Container
        fluid
        className="about-us-first-section d-flex align-items-center"
      >
        <Container className="about-us-introduction-container">
          <Row>
            <Col className={"about-us-introduction-texts-col col-lg-8 col-10"}>
              <Row>
                <h2 className="about-us-ceo-description-title">
                  {getLanguageFile(state.language).AboutUs.ceoDescriptionTitle}
                </h2>
              </Row>
              <Row>
                <p className="about-us-ceo-description">
                  {getLanguageFile(state.language).AboutUs.ceoDescription}
                </p>
              </Row>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container>
        <SolutionCard
          solutionImg={TRAVEL_GUIDE}
          solutionTitle={
            <h2
              onClick={() => setShowModal(true)}
              className="qualityControlPopupText"
            >
              {getLanguageFile(state.language).AboutUs.qualityPolicy}
            </h2>
          }
        />
      </Container>
      <Container>
        <SolutionCard
          solutionImg={TRAVEL_GUIDE}
          solutionTitle={
            <h2
              onClick={() => setShowRiskModal(true)}
              className="qualityControlPopupText"
            >
              {getLanguageFile(state.language).AboutUs.riskPolicy}
            </h2>
          }
        />
      </Container>
      <h2 className="patents-header-text">
        {getLanguageFile(state.language).AboutUs.downloadCatalog}
      </h2>
      <Container className="patents">
        <PatentsCard
          newsImg={ETE_PRODUCTS}
          newsDescription={
            getLanguageFile(state.language).AboutUs.downloadCatalog
          }
          patent={
            state.language === "en" ? "ETEProducts.pdf" : "ETEUrunler.pdf"
          }
        />
      </Container>
      <h2 className="patents-header-text">
        {getLanguageFile(state.language).AboutUs.trademarks}
      </h2>
      <Container className="patents">
        <PatentsCard
          newsImg={trademark_adam_staff}
          newsDescription={
            <>
              adam STAFF<sup>®</sup>
            </>
          }
          patent={"TrademarkAdamStaff.pdf"}
        />
        <PatentsCard
          newsImg={trademark_arts}
          newsDescription={
            <>
              arts<sup>®</sup>
            </>
          }
          patent={"TrademarkArts.pdf"}
        />
        <PatentsCard
          newsImg={trademark_batp}
          newsDescription={
            <>
              batP<sup>®</sup>
            </>
          }
          patent={"Trademarkbatp.pdf"}
        />
        <PatentsCard
          newsImg={trademark_hymots}
          newsDescription={
            <>
              hymots<sup>®</sup>
            </>
          }
          patent={"TrademarkHymots.pdf"}
        />
        <PatentsCard
          newsImg={trademark_nginr}
          newsDescription={
            <>
              nginr<sup>®</sup>
            </>
          }
          patent={"TrademarkNGINR.pdf"}
        />
        <PatentsCard
          newsImg={trademark_etecube}
          newsDescription={
            <>
              etecube<sup>®</sup>
            </>
          }
          patent={"TrademarkEtecube.pdf"}
        />
        {/* <PatentsCard
          newsImg={trademark_sama_isr}
          newsDescription={"samaISR"}
          patent={"PatentSamaISR.pdf"}
        /> */}
      </Container>
      <h2 className="patents-header-text">
        {getLanguageFile(state.language).AboutUs.certificates}
      </h2>
      <Container className="patents">
        <PatentsCard
          newsImg={SERTIFIKA_KALITE}
          newsDescription={"ISO 9001:2015"}
          patent={"SERTIFIKA_KALITE_YONETIM_SISTEMI_BELGESI.pdf"}
        />
        <PatentsCard
          newsImg={SERTIFIKA_AQAP}
          newsDescription={"AQAP 2110"}
          patent={
            state.language === "en"
              ? "SERTIFIKA_AQAP_ENG.PDF"
              : "SERTIFIKA_AQAP_TR.PDF"
          }
        />
      </Container>
      <h2 className="patents-header-text">
        {getLanguageFile(state.language).AboutUs.pressReleases}
      </h2>
      <Container className="patents">
        <PatentsCard
          newsImg={
            state.language === "en"
              ? BASIN_BULTENI_CATALYST_SPRINT3_EN
              : BASIN_BULTENI_CATALYST_SPRINT3_TR
          }
          newsDescription={aboutUsText.pressReleaseCatalystSprint3}
          patent={
            state.language === "en"
              ? "ETE Press Release_Catalyst_Sprint3.pdf"
              : "ETE_Press_Release_Catalyst_Sprint3_TR.pdf"
          }
        />
        <PatentsCard
          newsImg={BASIN_BULTENI_EFES}
          newsDescription={
            getLanguageFile(state.language).AboutUs.pressReleaseEfes26
          }
          patent={
            state.language === "en"
              ? "BasinBulteni_Efes2026_eng.pdf"
              : "BasinBulteni_Efes2026_tr.pdf"
          }
        />
        <PatentsCard
          newsImg={BASIN_BULTENI_CATALYST}
          newsDescription={
            getLanguageFile(state.language).AboutUs.pressReleaseCatalyst
          }
          patent={
            state.language === "en"
              ? "BasinBulteni_Catalyst_eng.pdf"
              : "BasinBulteni_Catalyst_tr.pdf"
          }
        />
      </Container>
      <Container fluid className="news-container">
        <h2 className="news-heading-text">
          {getLanguageFile(state.language).AboutUs.news}
        </h2>

        {recentNews.length > 0 ? (
          <Slider
            key={recentNews.map(news => news.id).join("-")}
            style={{ width: "70%" }}
            {...sliderSettings}
          >
            {recentNews.map(news => (
              <NewsCard
                key={news.id}
                newsImg={news.image}
                goTo={news.url}
                newsDescription={aboutUsText[news.descriptionKey]}
              />
            ))}
          </Slider>
        ) : (
          currentDate && <p>{aboutUsText.noRecentNews}</p>
        )}
        <Link to={"https://www.linkedin.com/company/etesolutions/"}>
          <h2 className="view-all-text">
            {getLanguageFile(state.language).AboutUs.viewAllNews}
          </h2>
        </Link>
      </Container>
      <Footer extraStyle={{ zIndex: 9999, backgroundColor: "white" }} />
      <QualityControlModal
        showModal={showModal}
        state={state}
        getLanguageFile={getLanguageFile}
        onHide={() => setShowModal(false)}
      />
      <RiskManagementModal
        showModal={showRiskModal}
        state={state}
        getLanguageFile={getLanguageFile}
        onHide={() => setShowRiskModal(false)}
      />
    </Container>
  )
}

export default AboutUsPage
